import { Progress } from "antd"
import React from "react"

import { brand, neutral } from "../tokens"
import type { WidgetProps, WidgetState } from "../types"
import { WidgetFrame } from "../WidgetFrame"

const clampPercent = (value: number, max: number): number => {
  if (!Number.isFinite(value) || !Number.isFinite(max) || max <= 0) return 0
  return Math.max(0, Math.min(100, Math.round((value / max) * 100)))
}

export const ProgressWidget = ({
  widget,
  payload,
  state,
  onRefresh,
  onExpand
}: WidgetProps) => {
  const data = payload?.progress
  const title = widget.config?.title ?? widget.title
  const effectiveState: WidgetState = state ?? (data ? "ready" : "loading")

  const percent = data ? clampPercent(data.value, data.max ?? 100) : 0

  return (
    <WidgetFrame
      title={title}
      state={effectiveState}
      capabilities={widget.capabilities}
      widgetId={widget.id}
      onRefresh={onRefresh}
      onExpand={onExpand}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {data?.label && (
          <span style={{ fontSize: 12, fontWeight: 600, color: neutral.muted }}>
            {data.label}
          </span>
        )}
        <Progress percent={percent} strokeColor={brand.teal} />
      </div>
    </WidgetFrame>
  )
}
